import React from 'react'
import TransitionLink from 'gatsby-plugin-transition-link'

import { ReactComponent as TivityLogoColor } from 'src/media/images/tivity-logo-color.svg'
import styles from './styles.module.scss'

const WhiteLabelFooter = ({ location }) => {
  const date = new Date()
  const year = date.getFullYear()
  return (
    <footer className={styles.footer}>
      <div className={styles.poweredBy}>
        Powered by{' '}
        <TivityLogoColor className={styles.logo} title="Tivity Health" />
      </div>
      Copyright © {year} Tivity Health, Inc.{' '}
      <TransitionLink
        entry={{ length: 0.5, duration: 0.1 }}
        exit={{
          length: 0.5,
        }}
        data-track="Footer - Terms/Service"
        to="/terms"
        state={{ prevLocation: location.pathname }}
      >
        Privacy Policy and Terms of Use
      </TransitionLink>
    </footer>
  )
}

export default WhiteLabelFooter
